import React, { useEffect, useState } from 'react'

import { UIButton, UISpacing, UIText } from 'components'
import { useAuthorizationContext, useClientContext } from 'contexts'
import { appVersionLowerThanCurrent } from 'utils'
import { useGlobalContext } from 'contexts/global'
import { InfoIcon } from 'assets/info'
import { FEEDBACK_STATUS } from 'constants/feedback'

import * as S from './styles'
import { TFeedbackPageProps } from './types'

export const Feedback = ({ status, onContinue }: TFeedbackPageProps) => {
  const { redirectUri } = useAuthorizationContext()
  const { appInfoContext } = useGlobalContext()
  const { client } = useClientContext()

  const [isLoading, setIsLoading] = useState(false)

  const isAndroid = /android/.test(window.navigator.userAgent.toLowerCase())

  useEffect(() => {
    if (redirectUri && isAndroid && !appVersionLowerThanCurrent(appInfoContext, '15.7.5')) {
      setIsLoading(true)
      const timer = setTimeout(() => {
        setIsLoading(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [])

  return (
    <S.FeedbackPage>
      <S.FeedbackPageContent>
        {status === 'noConsents' ? (
          <InfoIcon />
        ) : (
          <img src={FEEDBACK_STATUS[status].icon} alt="Signal Error" />
        )}
        <UISpacing mb="sm" />
        <UIText variant="headline-h1" semiBold>
          {FEEDBACK_STATUS[status].title.replaceAll(':clientName', client?.name ?? '[client]')}
        </UIText>
        <UISpacing mb="xs" />
        <UIText variant="body-3" semiBold>
          {FEEDBACK_STATUS[status].description}
        </UIText>
      </S.FeedbackPageContent>
      {status !== 'noConsents' && (
        <div>
          <UIButton variant="primary" fullWidth isLoading={isLoading} onClick={onContinue}>
            {FEEDBACK_STATUS[status].button}
          </UIButton>
        </div>
      )}
    </S.FeedbackPage>
  )
}
